import { useCallback } from "react";

import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";
import { Policy } from "types/generated";
import { AccessResult, hasAtLeastReadAccess, NO_ACCESS_MESSAGE } from "utils/access";

const useCanReadPolicy = (): ((
  policy?: Pick<Policy, "space" | "spaceDetails">
) => AccessResult) => {
  const { viewer } = useTypedContext(AccountContext);

  return useCallback(
    (policy?: Pick<Policy, "space" | "spaceDetails">) => {
      if (!policy) {
        return { result: false };
      }

      if (viewer.admin) {
        return { result: true };
      }

      // TODO: remove this once we have a proper type for the spaceDetails in query results
      return hasAtLeastReadAccess(viewer, policy.space || policy.spaceDetails?.id)
        ? { result: true }
        : { result: false, message: NO_ACCESS_MESSAGE };
    },
    [viewer]
  );
};

export default useCanReadPolicy;
